import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import Pagination from "../../utils/Pagination";
import { ImCross } from "react-icons/im";
import { createUser, deleteUser, fetchUserById, fetchUsers, updateUser, fetchBlocks, fetchPanchayats } from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";


const Supervisor = () => {
  const [supervisor, setSupervisor] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editBlock, setEditBlock] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [blockToDelete, setBlockToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const blocksPerPage = 10;
  const [sortAscending, setSortAscending] = useState(true);
  const history = useHistory();


  const handleMoveDetails = () => {
    history.push("/add-supervisor-details");
  };


  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    emailId: "",
    mobileNo: "",
    password: "",
    otp: "",
    roleId: 2,
    panchayatId: 0,
    activeStatus: true,
  });
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    // Name validation
    if (!formData.name || !formData.name.trim()) {
        formErrors.name = "Supervisor name is required";
        isValid = false;
    }
 
    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.emailId.trim()) {
      formErrors.emailId = "Email is required";
      isValid = false;
    } else if (!emailPattern.test(formData.emailId)) {
      formErrors.emailId = "Invalid email format";
      isValid = false;
    }

    // Mobile number validation
    const mobilePattern = /^\d{10}$/;
    if (!formData.mobileNo.trim()) {
      formErrors.mobileNo = "Phone number is required";
      isValid = false;
    } else if (!mobilePattern.test(formData.mobileNo)) {
      formErrors.mobileNo = "Phone number must be 10 digits";
      isValid = false;
    }

    // Password validation
    if (!formData.password || !formData.password.trim()) {
        formErrors.password = "Password is required";
        isValid = false;
    }

    // Block validation
    if (!formData.panchayatId) {
        formErrors.panchayatId = "Please select a block";
        isValid = false;
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; 
};

  const [selectedPanchayatId, setSelectedPanchayatId] = useState("");

  const [panchayatOptions, setPanchayatOptions] = useState([]);

  const fetchPanchayat = async () => {
    try {
      const response = await fetchPanchayats();
      setPanchayatOptions(response.data);
    } catch (error) {
      console.error("Error fetching panchayats data:", error);
    }
  };
  const fetchSupervisorData = async () => {
    setLoading(true);
    try {
      const response = await fetchUsers();
      const filteredData = response.data.filter((user) => user.roleId === 2);
      setSupervisor(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching supervisor data:", error);
    }finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPanchayat();
    fetchSupervisorData();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    setEditBlock(null);
    setErrors({});
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setBlockToDelete(null);
  };
  console.log("Form Data:", formData);
  console.log("Is Edit Modal Open:", isEditModalOpen);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value; 
    if (name === "mobileNo") {
      // Allow only digits by removing any non-numeric characters
      const numericValue = value.replace(/[^0-9]/g, "");

      // Update the formData state with the filtered value
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      // For other fields, update normally
      setFormData({
        ...formData,
        [name]: newValue,
      });
    }
  };
  const handleBlockChange = (e) => {
    const selectedId = e.target.value;
    setSelectedPanchayatId(selectedId);
    setFormData((prevData) => ({
      ...prevData,
      panchayatId: selectedId,
    }));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };
  const filteredBlocks = supervisor
    .filter(
      (block) =>
        block.name && block.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortAscending) {
        return a.name.localeCompare(b.name); // Ascending order
      } else {
        return b.name.localeCompare(a.name); // Descending order
      }
    });

  const pageCount = Math.ceil(filteredBlocks.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredBlocks.slice(startIndex, endIndex);
  };

  const handleCancel = () => {
    setFormData({
      id: 0,
    name: "",
    emailId: "",
    mobileNo: "",
    password: "",
    otp: "",
    roleId: 2,
    blockId: 0,
    activeStatus: true,
    });
    setIsEditModalOpen(false);
    setEditBlock(null);
    setIsDeleteModalOpen(false);
    setBlockToDelete(null);
    setErrors({});
  };

  const handleEditBlock = async (id) => {
    try {
      const response = await fetchUserById(id);
 
    console.log(response.data);
      setFormData(response.data);
      setSelectedPanchayatId(response.data.panchayatId);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching Supervisor details:", error);
    }
  };

  const handleSaveEditBlock = async () => {
    if (!validateForm()) return;
    setIsEditModalOpen(false);
    setLoading(true);
    console.log(formData);
    try {
      const response = await updateUser(formData.id, formData)
     console.log(response.data);
      handleCancel();
      setAlert({ visible: true, message: 'Supervisor updated successfully!', type: 'success' });
      // setSupervisor(updatedBlocks);
      fetchSupervisorData();
    } catch (error) {
      console.error("Error updating Supervisor:", error);
      setAlert({ visible: true, message: 'Error adding supervisor. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBlock = async () => {
    if (!blockToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      const response = await deleteUser(blockToDelete.id);
      console.log('Delete response:', response);
      const updatedBlocks = supervisor.filter(
        (block) => block.id !== blockToDelete.id
      );
      setSupervisor(updatedBlocks);
      handleCancel();
      setAlert({ visible: true, message: 'Supervisor deleted successfully!', type: 'success' });
      fetchSupervisorData();
    } catch (error) {
      console.error("Error deleting Supervisor:", error);
      setAlert({ visible: true, message: 'Error deleting block. Please try again.', type: 'error' });
    }finally {
      setLoading(false);
    }
  };


  const handleDeleteIconClick = (block) => {
    setBlockToDelete(block);
    setIsDeleteModalOpen(true);
  };

  return (
    <div className="houseState">
      {loading && <Loading/>}
      {!loading && (
      <div className="houseState-container box-shadow">
      {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
        <div className="container-head p-15">
          <h2>Supervisor</h2>
          <div className="btns">
            <span className="add-btn" onClick={handleMoveDetails}>
              <IoIosAddCircleOutline />
              <p>Add Supervisor</p>
            </span>
          </div>
        </div>
        <div className="table-filters">
          <div className="search-filter">
            <label htmlFor="searchName">
              <FaSearch />
            </label>
            <input
              type="text"
              id="searchName"
              placeholder="Search by Supervisor"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
       
        </div>
        <div className="houseState-content" style={{ overflowX: "auto" }}>
          <div className="table-container" >
            <table className="custom-table">
              <thead>
                <tr>
                <th onClick={handleSortByName} style={{ cursor: 'pointer' }}>
  Supervisor {sortAscending ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
</th>
                  <th>Phone Number</th>
                  <th>Mail</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageBlocks().length > 0 ? (
                  getCurrentPageBlocks().map((item) => (
                    <tr key={item.id}>
                      <td className="text-left">{item.name}</td>
                      <td className="text-center">{item.mobileNo}</td>
                      <td className="text-left">{item.emailId}</td>

                      <td className="text-center">
                        <p className={
                          item.activeStatus ? "active" : "inactive"
                        }>{item.activeStatus ? "Active" : "Inactive"}</p>
                      </td>
                      <td className="text-center">
                        <LuFileEdit onClick={() => handleEditBlock(item.id)} />
                        <FaRegTrashCan
                          onClick={() => handleDeleteIconClick(item)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center" colSpan="5">No Supervisors found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              currentPage={currentPage}
              totalPages={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      </div>
      )}


      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit Supervisor</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
             
                
            <div className={`add-form w-50 ${errors.name ? "error" : ""}`}>
                <label>Name:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
              </div>
              <div className={`add-form w-50 ${errors.password ? "error" : ""}`}>
                <label>Password:</label>
                <input
                  type="text"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className={errors.password ? "input-error" : ""}
                />
              </div>
              <div className={`add-form w-50 ${errors.mobileNo ? "error" : ""}`}>
                <label>Phone Number:</label>
                <input
                 type="text"
                 name="mobileNo"
                 value={formData.mobileNo}
                 placeholder="Phone Number"
                maxLength={10}  
                  onChange={handleInputChange}
                  className={errors.mobileNo ? "input-error" : ""}
                />
              </div>
              <div className={`add-form w-50 ${errors.panchayatId ? "error" : ""}`}>
                <label htmlFor="panchayatName">Panchayat Name</label>
                <select
                  name="panchayatName"
                  value={selectedPanchayatId}
                  onChange={handleBlockChange}
                  className={errors.panchayatId ? "input-error" : ""}
                >
                  <option value="" disabled>
                    Select Panchayat Name
                  </option>
                  {panchayatOptions.map((Panchayat) => (
                    <option key={Panchayat.id} value={Panchayat.id}>
                      {Panchayat.name} 
                    </option>
                  ))}
                </select>
              </div>
              <div className={`add-form w-50 ${errors.emailId ? "error" : ""}`}>
                <label>Email Id:</label>
                <input
                  type="email"
                  name="emailId"
                  value={formData.emailId}
                  onChange={handleInputChange}
                  className={errors.emailId ? "input-error" : ""}
                />
              </div>
              <div className={`add-form w-50 ${errors.activeStatus ? "error" : ""}`}>
                <label htmlFor="activeStatus">
                  Active Status:
                </label>
                <div className=" custom-radio-group">
                <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                </div>
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleSaveEditBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="screen">
          <div className="screen-container delete-popup">
            <h2>Are you sure you want to delete?</h2>
            <p>This action is permanent and cannot be undone.</p>

            <button
              onClick={handleDeleteBlock}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Supervisor;
